module.exports = __webpack_public_path__ + "img/Natur.76593f49.svg";